import type { HexColor } from '@getaccept/fried-tofu';
import type { HeroSectionLayout } from './enums/hero-section-layout';
import type { HeroSectionLayoutOrder } from './enums/hero-section-layout-order';
import type { HeroSectionMediaType } from './enums/hero-section-media-type';
import type { HeroSectionImageSize } from './enums/hero-section-image-size';

export enum HeroSectionFieldMergeKey {
  Address = 'address',
  CompanyName = 'companyName',
  Email = 'email',
  FirstName = 'firstName',
  LastName = 'lastName',
  Mobile = 'mobile',
  Title = 'title',
  Website = 'website',
  Zip = 'zip',
  State = 'state',
  City = 'city',
  Country = 'country',
  RegisteredNumber = 'registeredNumber',
  CompanyNumber = 'companyNumber',
  Value = 'value',
  Name = 'name',
}

export enum HeroSectionFieldCategory {
  Dealroom = 'dealroom',
  Owner = 'owner',
  Entity = 'entity',
}

export interface HeroSection {
  background: HeroSectionBackground;
  layout: HeroSectionLayout;
  layoutOrder: HeroSectionLayoutOrder;
  media?: HeroSectionMedia | null;
  textWidgetBackgroundColor?: HexColor;
  text?: string;
  fields?: HeroSectionField[];
  meetTeamText?: string;
  showLogo: boolean;
  __typename?: string;
}

export interface HeroSectionField {
  id: string;
  category: HeroSectionFieldCategory;
  mergeKey: HeroSectionFieldMergeKey;
  __typename?: string;
}

export enum HeroSectionBackgroundType {
  Image = 'image',
  GradientSolid = 'gradientSolid',
  GradientLinear = 'gradientLinear',
  GradientRadial = 'gradientRadial',
  GradientConic = 'gradientConic',
}

export interface HeroSectionBackground {
  type: HeroSectionBackgroundType;
  gradientColorOne: HexColor;
  gradientColorTwo: HexColor;
  gradientLightness: number;
  imageId?: string;
  __typename?: string;
}

export type HeroSectionMedia = HeroSectionMediaImage | HeroSectionMediaVideo;

export interface HeroSectionMediaImage {
  type: HeroSectionMediaType.Image;
  imageId: string;
  imageSize: HeroSectionImageSize;
  fullWidth: boolean;
  __typename?: string;
}

export interface HeroSectionMediaVideo {
  type: HeroSectionMediaType.Video;
  videoId: string;
  fullWidth: boolean;
  __typename?: string;
}

export type HeroSectionSelection = 'container' | 'textWidget' | 'mediaWidget' | 'teamText' | 'none';
